import { usePage } from '@inertiajs/inertia-vue3'
import { computed } from 'vue'

export function useCsrfToken() {
  const { props } = usePage()

  const csrfToken = computed(() => props.value.csrf_token ?? props.value.csrfToken)

  return {
    csrfToken
  }
}
